module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE_90_UP.ec4bea58.png";